var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-frame view"},[_c('header-com'),_c('menu-con'),_c('el-container',{staticClass:"home-box"},[_c('el-main',[_c('router-view'),_c('log')],1)],1),_c('footer-com')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }